import { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * DirectionGuard - Monitors and corrects any unexpected direction changes
 * Ensures document.dir stays in sync with the language context
 */
const DirectionGuard: React.FC = () => {
  const { dir, language } = useLanguage();

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const currentDir = document.documentElement.getAttribute('dir');
      const currentLang = document.documentElement.getAttribute('lang');
      
      // Check for mismatches and correct them
      if (currentDir !== dir) {
        if (process.env.NODE_ENV === 'development') {
          console.warn(`DirectionGuard: Correcting direction mismatch. Expected: ${dir}, Found: ${currentDir}`);
        }
        document.documentElement.setAttribute('dir', dir);
      }
      
      if (currentLang !== language) {
        if (process.env.NODE_ENV === 'development') {
          console.warn(`DirectionGuard: Correcting language mismatch. Expected: ${language}, Found: ${currentLang}`);
        }
        document.documentElement.setAttribute('lang', language);
      }
    }
  }, [dir, language]);

  // This component renders nothing - it's just a guardian
  return null;
};

export default DirectionGuard;